<div class="titulo-div ">
  <div class="titulos-div ">
    <div class="d-flex flex-row ">
      <h2 class="quicksand-bold title">TÍTULO: </h2>
      <h2 style=" margin-left: 5px;" class="quicksand-medium title ">{{titlesPlanData.title}}</h2>
    </div>
    <div class="d-flex flex-row flex-wrap " *ngIf="titlesPlanData.intermediateTitle">
      <h4 class="quicksand-bold subtitle">TÍTULO INTERMEDIO: </h4>
      <h4 style=" margin-left: 5px;" class="quicksand-medium subtitle ">{{titlesPlanData.intermediateTitle}}</h4>
    </div>
  </div>

  <div class="d-flex flex-row ">
    <h4 class="quicksand-bold subtitle">Duración:</h4>
    <h4 style=" margin-left: 5px;" class="quicksand-medium subtitle">{{workload}}</h4>
  </div>
</div>
<div class="articulacion-div" *ngIf="haveButtons">

  <h4 class="quicksand-bold">ARTICULACIÓN:</h4>
  <div class="articulacion-botones ">
    <ng-container *ngFor="let button of buttonStudyPlan;index as i">
      <button class="btn-articulacion quicksand-medium" *ngIf="button.state" (click)="open(button)">
        {{button.title}}</button>
    </ng-container>

  </div>
</div>
<div style="position: relative;  width: 100%;" class="mob" *ngIf="html">

  <!-- Vista previa -->
  <div style="position: relative;">
    <div (click)="expand()" class="pointer" [innerHTML]="html"></div>
    <button (click)="expand()" class="expand-btn" aria-label="Expandir contenido">
      <img src="./assets/img/arrows_output.png" alt="expandir">
    </button>
  </div>

  <!-- Modal de pantalla completa -->
  <div class="html-modal" *ngIf="isModalOpen">
    <div class="html-content-wrapper" (wheel)="zoom($event)" (mousedown)="startDrag($event)"
      (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()" [ngStyle]="{
     'transform': 'scale(' + scale + ') translate(' + translateX + 'px,' + translateY + 'px)',
     'cursor': isDragging ? 'grabbing' : 'grab'
   }">
      <div [innerHTML]="html"></div>
    </div>

    <button class="close-btn2" (click)="close(); $event.stopPropagation()">x</button>
  </div>
</div>

<div class="planEstudio-div">
  <div class="izq">
    <div *ngFor="let item of planData; let i = index" (click)="onSelectItem(i)"
      [ngClass]="{ 'item-activo': selectedItemIndex === i }" class="item-estudio">

      <span class="mas">+</span> <span class="quicksand-bold item-titulo"> {{item.title}}</span>
    </div>
    <div class="mb-3">
      <button class="btn-entrevista nunito-medium" (click)="openModal()">RECIBÍ MÁS INFORMACIÓN</button>
    </div>
    <div class="mobile linea"></div>
    <div style="position: relative;  width: 100%;" class="desk" *ngIf="html">

      <!-- Vista previa -->
      <div style="position: relative;">
        <div (click)="expand()" class="pointer" [innerHTML]="html"></div>
        <button (click)="expand()" class="expand-btn" aria-label="Expandir contenido">
          <img src="./assets/img/arrows_output.png" alt="expandir">
        </button>
      </div>

      <!-- Modal de pantalla completa -->
      <div class="html-modal" *ngIf="isModalOpen">
        <div class="html-content-wrapper" (wheel)="zoom($event)" (mousedown)="startDrag($event)"
          (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()" [ngStyle]="{
         'transform': 'scale(' + scale + ') translate(' + translateX + 'px,' + translateY + 'px)',
         'cursor': isDragging ? 'grabbing' : 'grab'
       }">
          <div [innerHTML]="html"></div>
        </div>

        <button class="close-btn2" (click)="close(); $event.stopPropagation()">x</button>
      </div>
    </div>

    <div style="margin-top: 25px" class="desk" #finishplanestudio>
      <div style="position: relative;">
        <a [href]="dataGeneral.banner_dos_image_link" target="_blank" rel="noopener">


          <img onerror="this.src='./assets/img/default.png'" [src]="apiUrl + dataGeneral.banner_dos_image_url" alt=""
            class="">

          <div class="text-img">
            <h1 [style.color]="dataGeneral.banner_dos_title_color" class="quicksand-bold">
              {{dataGeneral.banner_dos_title}}</h1>
            <span class="nunito-medium" [style.color]="dataGeneral.banner_dos_text_color">
              {{dataGeneral.banner_dos_text}}</span>

            <button class="nunito-medium zoomIn" id="button-banner"
              [style.color]="dataGeneral.banner_dos_button_text_color"
              [style.backgroundColor]="dataGeneral.banner_dos_button_background_color"
              [style.border]="'2px solid' +dataGeneral.banner_dos_button_border_color">
              + {{dataGeneral.banner_dos_button_text}}</button>


          </div>
        </a>
      </div>

      <!-- 
        <div style="position: relative;">

        <img onerror="this.src='./assets/img/default.png'" [src]="dataGeneral.banner_dos_image_mobile_url" alt="" class="">

       <div class="text-img">
      <h1 [style.color]="dataGeneral.banner_dos_title_color" class="quicksand-bold">
        {{dataGeneral.banner_dos_title}}</h1>
      <span class="nunito-medium" [style.color]="dataGeneral.banner_dos_text_color">
       {{dataGeneral.banner_dos_text}}</span>

       <a [href]="dataGeneral.image_link" target="_blank" rel="noopener">
          <button class="nunito-medium zoomIn" id="button-banner">
            + {{dataGeneral.banner_dos_button_text}}</button>
      </a>

       </div>
      </div>
      -->
    </div>
  </div>

  <div class="derecha">
    <h2 class="tituloBody nunito-bold">{{titlehtml | uppercase}}</h2>
    <div class="content-wrapper" [class.expanded]="expanded" #contentWrapper>
      <div [innerHTML]="htmlsanitizado" class="nunito-medium bodyplan"></div>
    </div>
    <hr>

    <div class="expand-container" *ngIf="showExpandButton">
      <button (click)="toggleExpand()" class="expand-button">
        {{ expanded ? 'ver -' : 'ver +' }}
      </button>
    </div>

  </div>
</div>
<div style="margin-top: 25px" class="mob">
  <div style="position: relative;">
    <a [href]="dataGeneral.banner_dos_image_link" target="_blank" rel="noopener">

      <!-- <a [href]="dataGeneral.image_link" target="_blank" rel="noopener">
        <img onerror="this.src='./assets/img/default.png'" [src]="apiUrl + dataGeneral.image_url" alt="" class="">
      </a> -->
      <img onerror="this.src='./assets/img/default.png'" [src]="apiUrl + dataGeneral.banner_dos_image_mobile_url" alt=""
        class="">

      <div class="text-img2">
        <h1 [style.color]="dataGeneral.banner_dos_title_color" class="quicksand-bold">
          {{dataGeneral.banner_dos_title}}</h1>
        <span class="nunito-medium" [style.color]="dataGeneral.banner_dos_text_color">
          {{dataGeneral.banner_dos_text}}</span>

        <button class="nunito-medium zoomIn" id="button-banner" [style.color]="dataGeneral.banner_dos_button_text_color"
          [style.backgroundColor]="dataGeneral.banner_dos_button_background_color"
          [style.border]="'2px solid' + dataGeneral.banner_dos_button_border_color">
          + {{dataGeneral.banner_dos_button_text}}</button>


      </div>
    </a>
  </div>

</div>
<div class="titulo-div2 " style="margin-top: 25px;">

</div>

<div *ngIf="openModalForm" class="modal-backdrop-custom">
  <div class="modal d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h4 class="title">Completá tus datos para recibir más información</h4>
          <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">

          <div id="hubspot-form">
            <!-- Aquí insertás el formulario -->
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeModal()">Cerrar</button>
        </div>

      </div>
    </div>
  </div>
</div>